export const tableColumns = [
  { name: 'row_num', title: '#', getCellValue: row => row.row_num, isNumber: true },
  { name: 'actions', title: 'Actions', getCellValue: row => row },
  { name: 'created_at', title: 'Created At', getCellValue: row => row.created_at },
  { name: 'updated_at', title: 'Updated At', getCellValue: row => row.updated_at },
  { name: 'title', title: 'Title', getCellValue: row => row.title },
  { name: 'com_brand', title: 'Com Brand', getCellValue: row => row.com_brand },
  { name: 'published', title: 'Published', getCellValue: row => row.published },
];

export const tableColumnWidths = [
  { columnName: 'row_num', width: 60 },
  { columnName: 'actions', width: 100 },
  { columnName: 'created_at', width: 120 },
  { columnName: 'updated_at', width: 120 },
  { columnName: 'title', width: 500 },
  { columnName: 'com_brand', width: 100 },
  { columnName: 'published', width: 100 },
];

export const tableColumnExtensions = [
  { columnName: 'row_num', align: 'right' },
  { columnName: 'created_at', align: 'right' },
  { columnName: 'updated_at', align: 'right' },
  { columnName: 'published', align: 'center' },
];

export const tableFilteringStateColumnExtensions = [
  { columnName: 'row_num', filteringEnabled: false },
  { columnName: 'actions', filteringEnabled: false },
  { columnName: 'created_at', filteringEnabled: false },
  { columnName: 'updated_at', filteringEnabled: false },
];

export const tableSortingStateColumnExtensions = [
  { columnName: 'row_num', sortingEnabled: false },
  { columnName: 'actions', sortingEnabled: false },
  { columnName: 'created_at', sortingEnabled: true },
  { columnName: 'updated_at', sortingEnabled: true },
  { columnName: 'title', sortingEnabled: true },
  { columnName: 'com_brand', sortingEnabled: false },
];
